// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const electrode_hisui: PokeData = {
  "id": 10232,
  "name": "electrode-hisui",
  "height": 12,
  "weight": 710,
  "base_experience": 172,
  "types": [
    PokeType.ELECTRIC,
    PokeType.GRASS
  ],
  "api_moves": [
    "tackle",
    "stun-spore",
    "thunder-shock",
    "thunderbolt",
    "thunder-wave",
    "thunder",
    "screech",
    "self-destruct",
    "swift",
    "explosion",
    "rollout",
    "spark",
    "charge",
    "bullet-seed",
    "gyro-ball",
    "seed-bomb",
    "energy-ball",
    "discharge",
    "charge-beam",
    "electro-ball",
    "grassy-terrain",
    "chloroblast"
  ],
  "moves": [
    "tackle",
    "stun-spore",
    "thunder-shock",
    "thunderbolt",
    "thunder",
    "bullet-seed",
    "energy-ball",
    "grassy-terrain",
    "wild-charge",
    "leaf-tornado",
    "flower-rush",
    "thunder-fang",
    "quick-tempo"
  ],
  "evolution_chain": {
    "id": 44,
    "item": null,
    "species": [
      {
        "name": "voltorb",
        "order": 109,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "electrode",
        "order": 110,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 100,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 91,
    "speed": 202,
    "ability_power": 108
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "hisui"
} as const;
